import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import PS from 'mewe/utils/pubsub';
import { widthHideSidebars } from 'mewe/constants-layout';
import { StickyController } from 'mewe/utils/elements-utils';
import GestureUtils from 'mewe/utils/gesture-utils';

export default class SidebarLeft extends Component {

  @tracked mobileSidebarVisible;

  @action
  onInsert(element) {
    this.element = element;

    this.stickyController = new StickyController({
      element: element,
      isSidebar: true,
      isSecondary: this.args.isSecondary,
      sidebarOffset: this.args.sidebarOffset,
    });

    this.toggleMobileSidebarBind = this.toggleMobileSidebar.bind(this);
    this.handleResize = this.handleResize.bind(this);

    if (this.args.autoOpenOnMobile) {
      this.toggleMobileSidebar();
    }

    if (!this.args.disallowMobileExpandBtn) {
      this.initSwipeDetection();
    }
  }

  @action
  onDestroy() {
    this.removeOverlayClickHandler();
    PS.Unsub('sidebar.action.mobile', this.toggleMobileSidebarBind);

    // Clean up resize listener
    window.removeEventListener('resize', this.handleResize);

    if (!this.args.disallowMobileExpandBtn) {
      this.cleanupSwipeDetection();
    }
  }

  addOverlayClickHandler() {
    if (!this.toggleMobileSidebarBind) this.toggleMobileSidebarBind = this.toggleMobileSidebar.bind(this);
    document.querySelector('.app-dragover-overlay').addEventListener('click', this.toggleMobileSidebarBind);
  }

  removeOverlayClickHandler() {
    const el = document.querySelector('.app-dragover-overlay');
    el?.classList.remove('active');
    el?.removeEventListener('click', this.toggleMobileSidebarBind);
  }

  @action
  toggleMobileSidebar() {
    this.mobileSidebarVisible = !this.mobileSidebarVisible;

    const dragOverlay = document.querySelector('.app-dragover-overlay');

    if (this.mobileSidebarVisible) {
      // don't allow opening mobile sidebar on desktop screen.
      // at the same time don't block closing it in case it was opened in some way
      if (window.innerWidth > widthHideSidebars) {
        return;
      }

      dragOverlay.classList.add('active');
      this.addOverlayClickHandler();
      PS.Sub('sidebar.action.mobile', this.toggleMobileSidebarBind);
    } else {
      dragOverlay.classList.remove('active');
      this.removeOverlayClickHandler();
      PS.Unsub('sidebar.action.mobile', this.toggleMobileSidebarBind);
    }
  }


  // SWIPE DETECTION
  initSwipeDetection() {
    this.gestureUtils = new GestureUtils({
      minSwipeDistance: 50,
      maxVerticalDistance: 100,
      onSwipeLeftToRight: () => {
        // Only allow swipe gestures on mobile/tablet screens
        if (window.innerWidth > widthHideSidebars) {
          return;
        }
        if (!this.mobileSidebarVisible) {
          this.toggleMobileSidebar();
        }
      },
      onSwipeRightToLeft: () => {
        // Only allow swipe gestures on mobile/tablet screens
        if (window.innerWidth > widthHideSidebars) {
          return;
        }
        if (this.mobileSidebarVisible) {
          this.toggleMobileSidebar();
        }
      }
    });

    this.gestureUtils.initSwipeDetection();

    // Add resize listener to handle window size changes
    window.addEventListener('resize', this.handleResize);
  }

  cleanupSwipeDetection() {
    if (this.gestureUtils) {
      this.gestureUtils.cleanupSwipeDetection();
    }
  }

  handleResize() {
    // If window is resized to desktop size, close the mobile sidebar
    if (window.innerWidth > widthHideSidebars && this.mobileSidebarVisible) {
      this.toggleMobileSidebar();
    }
  }

}
